import React, { forwardRef } from "react";

import { makeStyles } from "@material-ui/styles";
import { Box, Typography, IconButton } from "@material-ui/core";
import { AppsIcon } from "../../../components/icons";

const useStyles = makeStyles(() => ({
  menu: {
    alignItems: "center",
    justifyContent: "space-between",
    display: "flex",
  },
  headUsername: {
    color: "white",
    fontSize: "0.75rem",
    marginRight: "0.25rem",
    lineHeight: "1rem",
    cursor: "default",
  },
}));

const AppButton = ({ username, onClick }, ref) => {
  const styles = useStyles();

  return (
    <Box className={styles.menu}>
      <Typography className={styles.headUsername}>{username}</Typography>
      <IconButton onClick={onClick} data-testid="app-menu-button">
        <Box ref={ref}>
          <AppsIcon />
        </Box>
      </IconButton>
    </Box>
  );
};

export default forwardRef(AppButton);
